import Api from '../Utils/Axios';

export const GetRoleList = async (params) => {
    const response = await Api.get('role/list', { params });
    return response.data;
};

export const GetSingleRole = async ({ Id }) => {
    const response = await Api.get(`role/${Id}`);
    return response.data;
};

export const CreateRole = async (data) => {
    // data: { name, permissions: string[], status: boolean }
    const response = await Api.post('role/', data);
    return response.data;
};

export const UpdateRole = async (data) => {
    // data: { id, name, permissions: string[], status: boolean }
    const response = await Api.put('role/', data);
    return response.data;
};

export const DeleteRole = async (id) => {
    const response = await Api.delete(`role/${id}`);
    return response.data;
};

export const UpdateRoleStatus = async ({ id }) => {
    const response = await Api.put('role/status', { id });
    return response.data;
};

export const GetAllPermissions = async () => {
    const response = await Api.get('role/permissions');
    return response.data;
};

export const RoleAutoComplete = async (params) => {
    const response = await Api.get('role/autocomplete', { params });
    return response.data;
};


